import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { CdkColumnDef } from '@angular/cdk/table';
import { PatientService } from '../../../services/patient.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '../../../util/utilService'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';
import moment from 'moment';
import { Injectable } from '@angular/core';
import { refreshService } from '../../../services/refersh.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { DoctorService } from '../../../services/doctor.service';
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return date.toDateString();
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};
@Component({
  selector: 'app-patient-receipt',
  templateUrl: './patient-receipt.component.html',
  styleUrls: ['./patient-receipt.component.scss'],
  providers: [
    MessageService,
    CdkColumnDef,
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ],
})
export class PatientReceiptComponent implements OnInit {

  @ViewChild("viewReceiptModal") viewReceiptModal!: ElementRef;
  @ViewChild("receiptContent_modal") receiptContent_modal!: ElementRef;
  visitReasonArr = [{ reason: 'Consultation', reasonAmount: "", selected: false }, { reason: 'Vaccination', reasonAmount: "", selected: false }, { reason: 'Vaccination + Consultation', reasonAmount: "", selected: false }, { reason: 'Services (nebulization,Dressing etc.)', reasonAmount: "", selected: false }, { reason: 'Medicines', reasonAmount: "", selected: false }, { reason: "Other", reasonAmount: "", selected: false, otherReason: "other" }]
  hideEditAndSaveutton: boolean = false;
  visitReason: any = []
  otherReason: any = ""
  displayedColumns: string[] = ['date', 'amount', 'action', 'view'];
  paymentMethod = ['Cash', 'UPI/G-Pay/Paytm/PhonePay', 'NEFT', 'Other']
  paymentMethodName = ""
  selectedTemplate: any = [];
  isReceiptLoading: boolean = false;
  amount: any = 0
  moment: any = moment;
  amountInWords: any;
  receiptPdfURL: any
  receiptURL: any
  receiptNo: any
  allReceiptArr: any = []
  receiptDate: any
  payerName: any
  minDate: any;
  pramPatientId: any;
  patientName = ""
  selectedReceipt: any
  showLoading: boolean = false;
  patientDataFromLocal: any;
  templateName: any = "Speciality";
  isPediatric = false
  isDateRangeEnabled: boolean = false;
  isProcessing = false;
  userId: any;
  isPageLoading: boolean = false;
  startDate: any = null;
endDate: any = null;
  @ViewChild('container') private container!: ElementRef;

  @Input() doctorObj: any
  @Input() patientObj: any;
  @Input() patientType: any
  constructor(public dialog: MatDialog, private refreshservice: refreshService, private util: UtilService, private sanitizer: DomSanitizer, private messageService: MessageService, private patientService: PatientService, private route: ActivatedRoute, private cd: ChangeDetectorRef, private authService: AuthService, private doctorService: DoctorService,) {
    this.receiptDate = new Date();
    this.minDate = new Date()
    this.userId = this.authService.getUser();
    console.log("userId", this.userId);

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params:any) => {
      this.pramPatientId = this.pramPatientId ? params.patientId : params.patientId
    })

    const patientDataString = localStorage.getItem('patientMoreData');

    let patientDataFromLocal: any;

    if (patientDataString) {
      patientDataFromLocal = JSON.parse(patientDataString);
    } else {
      // Handle the case when there is no data found for the given key
      patientDataFromLocal = {}; // or set to null, or any default value
      console.warn('No data found for key: patientMoreData');
    }


    if (this.patientType) {
      this.isPediatric = true
    }
    console.log("apr6", this.patientObj)
    this.patientName = patientDataFromLocal.firstName + " " + patientDataFromLocal.lastName;
    console.log("patientName", this.patientName);

    setTimeout(() => {
      this.getAllReceipt()
    }, 100)
    this.templateName = 'default';
    console.log("docObj", this.doctorObj)
    var services = [];

    try {
      if (this.doctorObj?.services) {
        services = JSON.parse(this.doctorObj.services);
      }
    } catch (e) {
      console.error("Failed to parse services JSON", e);
    }

    if (services.template_names) {
      this.templateName = services.template_names[0];
      this.selectedTemplate = services.template_names;
    }
    else {
      this.selectedTemplate.push('default');
    }
    
    this.loadMedicineAmount();
    this.getDoctorDetails();
  }

  addMoreRow = () => {

    this.visitReasonArr.push({ "reason": "", "reasonAmount": '', selected: false, otherReason: 'other' })
  }

  setReceiptItem(receipt: any) {
    this.selectedReceipt = receipt;
  }
  selectVisitReasonValue(item: any, index: any) {
    if (this.visitReasonArr[index].selected == true) {
      this.visitReasonArr[index].selected = false;
    }
    else {
      this.visitReasonArr[index].selected = true;
      this.visitReason.push({ "reason": item.reason, "reasonAmount": item.reasonAmount, selected: true })
    }
  }
  onClickBillDelete() {

    this.patientService.deleteReceipt(this.selectedReceipt).subscribe((response:any) => {
      if (response) {
        this.closeDialog();
        this.getAllReceipt();
      }
    });
  }
  onDropdownSelectTemplate = (item: any) => {
    this.templateName = item
  }
  getTotal(item: any) {

    let total = 0

    this.visitReasonArr.map(item => {
      if (item && item.reasonAmount != "") {
        item.selected = true
        total += Number(item.reasonAmount)


      }
    })
    this.amount = total
  }
  validateNumber(e: any, usedFor: any) {

    if (e.charCode === 13 && usedFor === 'receipt') {

    }

    if (usedFor === 'receipt') {
      return ((e.charCode > 47 && e.charCode < 58)) || (e.which == 8) || (e.which == 13) || (e.keyCode == 9)
    } else {
      return ((e.charCode > 47 && e.charCode < 58)) || (e.which == 8) || (e.which == 13) || (e.keyCode == 9) || (e.keyCode == 110) || (e.keyCode == 46)
    }
  }
  onClickViewReceipt(receipt: any, type: any) {

    console.log("receipt type", type);
    if (type === 'view') {
      this.hideEditAndSaveutton = true;
    }

    this.receiptPdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(receipt.billUrl);
    this.receiptURL = receipt.billUrl;
    this.openDialog(this.viewReceiptModal);
    //this.isViewRecipt = true;
  }
  openDialog(content: any) {
    this.dialog.open(content);
  }
  closeDialog() {

    this.dialog.closeAll();
  }
  loadMedicineAmount() {
    const storedData = localStorage.getItem('QuotationSummary');
    if (storedData) {
      const parsed = JSON.parse(storedData);

      if (Array.isArray(parsed) && parsed.length > 0) {
        const patientRecord = parsed.find((p: any) => p.PatientId == this.pramPatientId);

        if (patientRecord) {
          // ✅ Check date
          const todayStr = new Date().toISOString().split("T")[0];
          console.log("patientRecord.date", patientRecord.date, todayStr);
          if (patientRecord.date !== todayStr) {
            // ❌ Old record → clear storage
            localStorage.removeItem('QuotationSummary');
            return;
          }

          // ✅ Date matches → load medicine amount
          const medicinesReason = this.visitReasonArr.find(r => r.reason === 'Medicines');
          if (medicinesReason) {
            medicinesReason.reasonAmount = patientRecord.MedicineAmount || '';
            medicinesReason.selected = true;
          }

          // 🔹 Set the actual amount used in previewReceipt
          this.amount = Number(patientRecord.MedicineAmount) || 0;
        }
      }
    }
  }

  previewReceipt() {
    this.amount = this.amount

    this.amountInWords = this.util.numberToWord(this.amount);
    if (this.templateName == "Speciality") {
      // alert("hello")
      this.messageService.add({ severity: 'custom', detail: 'Please specify speciality before proceeding' });


    }
    else if (this.visitReasonArr.length == 0) {
      this.messageService.add({ severity: 'custom', detail: 'Please specify visit reason before proceeding' });

    }
    else if (this.amount === 0) {
      this.messageService.add({ severity: 'custom', detail: 'Please specify amount before proceeding' });

    }
    else {
      this.openDialog(this.receiptContent_modal)
    }
  }
  printReceipt(action: any, type?: any) {

    if (this.isReceiptLoading) return;

    if (type === 'editAndSave') {
      this.hideEditAndSaveutton = false;
    }

    const date: any = new Date(this.receiptDate);
    const nextDate: any = date ? date.toDateString() : '';

    if (this.templateName == "Speciality") {
      this.messageService.add({ severity: 'custom', detail: 'Please specify speciality before proceeding' });
      return;
    }

    if (this.visitReasonArr.length === 0) {
      this.messageService.add({ severity: 'custom', detail: 'Please specify visit reason before proceeding' });
      return;
    }

    if (this.amount === 0) {
      this.messageService.add({ severity: 'custom', detail: 'Please specify amount before proceeding' });
      return;
    }

    this.isReceiptLoading = true;

    // 🔥 CAPTURE EVERYTHING
    const finalAmount = this.amount;
    const finalAmountInWords = this.util.numberToWord(finalAmount);
    const finalVisitReasonArr = JSON.parse(JSON.stringify(this.visitReasonArr));
    const finalStartDate = this.startDate;   // ✅ FIX
    const finalEndDate = this.endDate;       // ✅ FIX

    const filteredReasons = finalVisitReasonArr
      .filter((x: any) => x.selected)
      .map((item: any) => ({
        reason: item.reason || 'Other',
        reasonAmount: item.reasonAmount || ''
      }));

    setTimeout(() => {

      const postData: any = {
        patient_id: this.patientObj.id || this.pramPatientId,
        type: 'Receipt',
        billDate: nextDate,
        billNo: this.receiptNo || '',
        amount: finalAmount,
        amountInWords: finalAmountInWords.charAt(0).toUpperCase() + finalAmountInWords.slice(1),
        action: action,
        payerName: this.payerName || '',
        paymentMethodName: this.paymentMethodName || "",
        templateName: this.templateName,
        visitReason: JSON.stringify(filteredReasons)
      };

      // ✅ FIXED (NO UI DEPENDENCY)
      if (finalStartDate && finalEndDate) {
        postData.receiptFromDate = this.formatDateToYYYYMMDD(finalStartDate);
        postData.receiptToDate = this.formatDateToYYYYMMDD(finalEndDate);
      }

      console.log("FINAL POST DATA", postData);

      this.patientService.printReceipt(postData).subscribe({
        next: (response: any) => {

          if (response) {
            this.receiptPdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(response.url);
            this.receiptURL = response.url;

            if (action === 'preview') {
              setTimeout(() => {
                this.openDialog(this.viewReceiptModal);
                this.isReceiptLoading = false;
              }, 100);
            }

            if (action === 'share') {
              this.closeAddReceiptModal();
              this.closeDialog();
              this.isReceiptLoading = false;
            }

            this.getAllReceipt();
          }
        },
        error: () => {
          this.isReceiptLoading = false;
        }
      });

    }, 200);
  }
  formatDateToYYYYMMDD(date: any): string {
  if (!date) return '';

  const d = new Date(date);
  const year = d.getFullYear();
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);

  return `${year}-${month}-${day}`;
}
  onClickBillShare(billUrl: any) {
    var postData = {
      patient_id: this.patientObj.id ? this.patientObj.id : this.patientObj._id,
      url: billUrl
    }
    this.patientService.shareReceipt(postData).subscribe((response:any) => {
      if (response) {

      }
    });
  }
  getDoctorDetails = () => {

    this.isPageLoading = true; // ✅ START LOADER

    const params = {
      user_id: this.userId
    };

    this.doctorService.getDetails(params).subscribe({

      next: (response: any) => {

        if (!response?.doctor) return;

        let drService: any = null;

        // ✅ SAFE PARSE
        try {
          drService = response.doctor.services
            ? JSON.parse(response.doctor.services)
            : null;
        } catch (e) {
          console.error("Service parse error", e);
        }

        console.log("drService", drService);

        // ✅ HANDLE BOOLEAN + STRING
        const isPhysioEnabled = String(drService?.PhysiotherapyReceipt) === 'true';

        if (!isPhysioEnabled) return;

        // ✅ CHECK ALREADY EXISTS
        const alreadyAdded = this.visitReasonArr.some(
          (r: any) => r.reason === 'Physiotherapy'
        );

        if (alreadyAdded) return;

        // ✅ FIND "Medicines"
        const medicineIndex = this.visitReasonArr.findIndex(
          (r: any) => r.reason === 'Medicines'
        );

        if (medicineIndex !== -1) {

          // ✅ INSERT AFTER MEDICINES
          this.visitReasonArr.splice(
            medicineIndex + 1,
            0,
            { reason: 'Physiotherapy', reasonAmount: "", selected: false },
            { reason: 'Sensory integration therapy', reasonAmount: "", selected: false },
            { reason: 'Sensory Diet', reasonAmount: "", selected: false }
          );

        } else {

          // ✅ FALLBACK (if Medicines not found)
          this.visitReasonArr.push(
            { reason: 'Physiotherapy', reasonAmount: "", selected: false },
            { reason: 'Sensory integration therapy', reasonAmount: "", selected: false },
            { reason: 'Sensory Diet', reasonAmount: "", selected: false }
          );
        }
      },

      error: (err) => {
        console.error("Doctor API Error", err);
      },

      complete: () => {
        this.isPageLoading = false; // ✅ ALWAYS STOP LOADER
      }

    });
  };
  closeAddReceiptModal() {
    this. isDateRangeEnabled = false;

this.startDate = null;
this.endDate = null;
    this.paymentMethodName = "";
    this.payerName = ""
    this.receiptDate = new Date();
    this.amount = 0;
    this.receiptNo = '';
    this.visitReason = '';
    let visits = this.visitReasonArr
    visits.map(ins => {
      if (ins.selected = true) {
        ins.selected = false
        ins.reasonAmount = ""

      }
      if (ins.otherReason == "other") {
        ins.reason = ""
      }
    })
    this.visitReasonArr = visits
  }
  getAllReceipt() {

    this.showLoading = true;
    var postData = {
      patient_id: this.patientObj.id ? this.patientObj.id : this.pramPatientId,
    }
    console.log("getAllReceipt postdata", postData, this.patientObj.id);

    this.patientService.getAllReceipt(postData,).subscribe((response: any) => {
      this.showLoading = false;
      if (response) {
        console.log("res", response)
        for (let index = 0; index < response.bills.length; index++) {
          const element = response.bills[index];

          element.date = moment(element.date).format('DD/MM/YYYY')
        }
        this.allReceiptArr = response.bills
        this.allReceiptArr.map((ins: any) => {
          var matches = ins.visitReason.match(/\[(.*?)\]/);
          if (matches) {
            ins.visitReason = JSON.parse(ins.visitReason)
          }
          else {
            ins.visitReason = [{ "reason": ins.visitReason }];
          }
        })
        this.allReceiptArr = this.allReceiptArr.filter((item: any) => item.billUrl !== null && item.billUrl !== '');
        console.log("allReceiptArr 123", this.allReceiptArr);

        this.allReceiptArr = new MatTableDataSource(this.allReceiptArr)
        console.log("allReceiptArr", this.allReceiptArr);


      }

    });
    // this.refreshservice.documentRefershed()
  }
  onDropdownSelecPayment(value: any) {
    this.paymentMethodName = value

  }
  toggleDateRange(value: boolean) {
  this.isDateRangeEnabled = value;

  if (!value) {
    this.startDate = null;
    this.endDate = null;
  }
}
}